import React, { useEffect, useState } from "react";
import axios from "axios";
import { Phone, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = "https://www.frendrops.in/api";

export default function Login() {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [acceptedLegal, setAcceptedLegal] = useState(false);
  const [legalError, setLegalError] = useState("");
  const [loading, setLoading] = useState(false);

  const sendOTP = async (e: React.FormEvent) => {
    e.preventDefault();

    if (phoneNumber.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }

    if (!acceptedLegal) {
      setLegalError(
        "Please accept Terms & Conditions and Privacy Policy to continue."
      );
      return;
    }

    setLegalError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/send-otp`,
        {
          phone_prefix: "+91",
          phone_number: phoneNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("OTP Response:", response.data);

      if (response.data.success) {
        // Store the phone information temporarily.
        sessionStorage.setItem("login_mobile", phoneNumber);
        sessionStorage.setItem("login_phone_prefix", "+91");

        navigate("/otp-verification", {
          state: {
            phoneNumber: `+91${phoneNumber}`,
            mobile: phoneNumber,
            phonePrefix: "+91",
          },
        });
      } else {
        alert(
          response.data.message ||
            "Unable to send OTP."
        );
      }
    } catch (error: any) {
      console.error(
        "Send OTP Error:",
        error?.response?.data || error
      );

      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to send OTP."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      // Nothing required here.
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f4f6fb] flex flex-col">

      {/* Back button */}
      <div className="px-4 pt-4">
        <button
          type="button"
          onClick={() => navigate(-1)}
          disabled={loading}
          className="p-2 rounded-full hover:bg-gray-200 transition"
          aria-label="Go back"
        >
          <ArrowLeft size={24} />
        </button>
      </div>

      {/* Top section */}
      <div className="text-center px-5 py-8">

        <h1 className="text-xl font-semibold text-purple-700">
          Pooja Samagri & Fresh Flowers
        </h1>

        <p className="text-sm text-purple-700 mt-2">
          Delivered with devotion to your doorstep
        </p>

      </div>

      {/* Bottom card */}
      <div className="bg-white rounded-t-[30px] flex-1 px-5 pt-6 pb-8">

        <div className="max-w-md mx-auto">

          <h2 className="text-xl font-semibold mb-5">
            Sign up or Login
          </h2>

          <form
            onSubmit={sendOTP}
            className="space-y-4"
          >

            {/* Mobile */}
            <div className="flex border border-gray-300 rounded-xl overflow-hidden h-[50px]">

              <div className="flex items-center px-3 bg-gray-100 font-medium">
                +91
              </div>

              <div className="flex items-center px-3 text-gray-500">
                <Phone size={20} />
              </div>

              <input
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                value={phoneNumber}
                onChange={(e) => {
                  const value =
                    e.target.value.replace(/\D/g, "");

                  setPhoneNumber(value);

                  if (value.length === 10) {
                    setLegalError("");
                  }
                }}
                placeholder="Enter Mobile Number"
                maxLength={10}
                disabled={loading}
                className="flex-1 outline-none px-2 text-base"
              />

            </div>

            {/* Validation */}
            {phoneNumber.length > 0 &&
              phoneNumber.length !== 10 && (
                <p className="text-xs text-red-500">
                  Enter a valid 10 digit mobile number.
                </p>
              )}

            {/* Terms */}
            <div className="flex items-start gap-3 mt-3">

              <input
                id="legal"
                type="checkbox"
                checked={acceptedLegal}
                onChange={(e) => {
                  setAcceptedLegal(e.target.checked);

                  if (e.target.checked) {
                    setLegalError("");
                  }
                }}
                disabled={loading}
                className="mt-1 h-4 w-4 accent-purple-700"
              />

              <label
                htmlFor="legal"
                className="text-sm leading-5 text-gray-500"
              >
                I agree to{" "}
                <button
                  type="button"
                  onClick={() =>
                    navigate("/terms-conditions")
                  }
                  className="text-purple-700 underline font-semibold"
                >
                  Terms & Conditions
                </button>{" "}
                and{" "}
                <button
                  type="button"
                  onClick={() =>
                    navigate("/privacy-policy")
                  }
                  className="text-purple-700 underline font-semibold"
                >
                  Privacy Policy
                </button>
              </label>

            </div>

            {/* Legal error */}
            {legalError && (
              <p className="text-xs text-red-500">
                {legalError}
              </p>
            )}

            {/* Send OTP */}
            <button
              type="submit"
              disabled={
                loading ||
                phoneNumber.length !== 10 ||
                !acceptedLegal
              }
              className={`w-full h-[50px] rounded-xl text-white font-semibold flex items-center justify-center ${
                loading ||
                phoneNumber.length !== 10 ||
                !acceptedLegal
                  ? "bg-gray-300"
                  : "bg-purple-700 hover:bg-purple-800"
              }`}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>

          </form>

        </div>

      </div>
    </div>
  );
}
